import React, { useEffect, useState } from "react";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, Select } from "antd";
import Header from "../../common/Header";
import ApiService from "../../../Service/ApiService";
import { notify } from "../../common/Toast";
import "../../common/forms.css";

const CreateUser = () => {
  const location = useLocation();
  const [user, setUser] = useState();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const roles = [
    { label: "Admin", value: "ADMIN" },
    { label: "Super Admin", value: "SUPERADMIN" },
  ];

  useEffect(() => {
    if (location) {
      setUser(location.state?.admin);
      form.setFieldsValue(location.state?.admin);
    }
  }, [location]);

  const handleSubmit = async (values) => {
    if (user) values.version = user.version;
    setLoading(true);
    let result = await ApiService.saveUser(values);

    if (result) {
      navigate(-1);
    }
    setLoading(false);
  };

  return (
    <div className="default-container">
      <Header title={user ? "Manage User Details" : "Create a new User"} />
      <div className="form-page-container">
      <Form
        name="user-form"
        initialValues={user}
        onFinish={handleSubmit}
        form={form}
        layout="vertical"
      >
        <Form.Item label="Id" name="id" hidden={true}>
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please input a user name!",
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            {
              required: true,
              message: "Please input a valid user email address",
              type: "email",
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          label="Phone Number"
          name="phoneNumber"
          rules={[
            {
              required: true,
              message: "Please input a phone number!",
            },
          ]}
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Role" name="role">
          <Select options={roles} size="large" />
        </Form.Item>
        <Form.Item className="action-button-default">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            disabled={loading}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
      </div>
    </div>
  );
};

export default CreateUser;
